import React from "react";
import { Button, CircularProgress } from "@mui/material";

function CustomButton({
  label = "Click Me",
  onClick = () => {},
  icon = null,
  variant = "contained",
  size = "small",
  //gradient = '#0070C2',
  gradient = "#0070C2",
  className = "",
  fullWidth = false,
  type = "button",
  isLoading = false,
  loadingText = "Loading...",
  ...rest
}) {
  return (
    <Button
      variant={variant}
      type={type}
      onClick={onClick}
      startIcon={!isLoading ? icon : null}
      size={size}
      fullWidth={fullWidth}
      sx={{
        height: "28px",
        minHeight: "28px",
        minWidth: 0,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        lineHeight: "normal",
        WebkitFontSmoothing: "antialiased",
        "& .MuiButton-startIcon": {
          margin: "0",
          marginInlineEnd: "8px",
          marginInlineStart: "-2px",
          display: "flex",
          alignItems: "center",
          height: "100%",
        },
        "& .MuiButton-endIcon": {
          marginInlineStart: "8px",
          marginInlineEnd: "-2px",
        },
        "& .MuiButton-label": {
          display: "flex",
          alignItems: "center",
        },
        "&.Mui-disabled": {
          backgroundColor:
            variant === "contained" ? "#94a3b8 !important" : "transparent",
          color: "#ffffff",
        },
      }}
      style={{
        backgroundColor:
          variant === "contained" && !isLoading ? gradient : undefined,
        position: "relative",
      }}
      className={`!p-0 !px-4 !text-[12px] !rounded-[6px] !leading-none !flex !items-center !justify-center whitespace-nowrap !shadow-none ${className}`}
      disabled={isLoading}
      {...rest}
    >
      {isLoading ? (
        <div className="flex items-center justify-center gap-2">
          <CircularProgress
            size={20}
            thickness={4}
            style={{
              color: variant === "contained" ? "#ffffff" : "#ffffff",
            }}
          />
          <p className="text-white">{loadingText}</p>
        </div>
      ) : (
        label
      )}
    </Button>
  );
}

export default CustomButton;
